'use strict';

/**
 * Replaces keys with actual values as long as the key is inside curly braces: {key}
 * @module tokenReplace
 * @param {String} str The string to replace values in
 * @param {Object} o JSON Object containing key/value pairs to replace and use
 * @param {String} delim one or two character string expressing open / close delimiter(s) for the tokens. Defaults to '{}'
 * @returns String with tokens replaced
 * @example: tokenReplace("My name is {name}.  I work at {company}.", { name: "Dale", company: "1stdibs" });
 */
module.exports = function tokenReplace(str, o, delim) {
    var pattern;
    delim = undefined === delim ? '{}' : delim;
    pattern = new RegExp('\\' + delim.slice(0, 1) + '+([^' + '\\' + delim.split('').join('\\') + ']*)' + '\\' + delim.slice(-1) + '+', 'g');

    if (typeof str !== 'string') {
        return str;
    }

    return str.replace(pattern,
        function (a, b) {
            var r = o[b];
            return typeof r === 'string' || typeof r === 'number' ? r : a;
        }
    );
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-token-replace/index.js
// module id = 87
// module chunks = 63